"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlLanguage = function (locale, extended) {
    if (extended === void 0) { extended = true; }
    locale = locale.toLowerCase();
    var language = locale.split('-')[0];
    var rewrites = {
        'nb-no': 'no',
        'pt-pt': 'pt',
        'pt-br': 'pt-br',
        'zh-cn': 'zh-Hans',
        'zh-tw': 'zh-Hant',
    };
    if (rewrites[locale]) {
        return rewrites[locale];
    }
    var baseLanguages = [
        'en', 'ar', 'bg', 'cs', 'da', 'de', 'el', 'es', 'et', 'fi', 'fr', 'he', 'hi', 'hu',
        'id', 'it', 'ja', 'ko', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sv', 'tr', 'uk'
    ];
    if (baseLanguages.indexOf(language) > -1) {
        return language;
    }
    // Extended set of supported locales include: ca-ES, en-GB, es-MX, es-US, hr-HR, lt-LT, lv-LV, ms-MY, sk-SK, sl-SL, sr-Latn-RS, vi-VN
    if (extended) {
        if (['en-gb', 'es-mx', 'es-us'].indexOf(locale) > -1) {
            return locale;
        }
        if (['ca', 'hr', 'lt', 'lv', 'ms', 'sk', 'sl', 'sr', 'vi'].indexOf(language) > 0) {
            return language;
        }
    }
    return 'en';
};
//# sourceMappingURL=getUrlLanguage.js.map